import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function PromoBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(86347);
  return <div className="border-b border-night-600 bg-night-950" data-id="element-276" data-mp="8biahh3z72pz">
      <div className="mx-auto flex max-w-shell items-center justify-between gap-4 px-5 py-2.5 sm:px-6" data-id="element-277" data-mp="3hnk5utv7phx">
        <p className="min-w-0 truncate text-[11px] text-cream sm:text-sm" data-id="element-278" data-mp="3uo8fhqqydjkr">
          <span className="mr-1.5 font-bold uppercase tracking-wider text-amber" data-id="element-279" data-mp="3qny1prwx5ovc">Promo</span>
          <span className="hidden sm:inline" data-id="element-280" data-mp="3lnsgath8sylp">6-volume bundle + 6 free bonuses — </span>
          only $27. Offer ends tonight.
        </p>
        <p className="flex shrink-0 items-center gap-2" data-id="element-281" data-mp="3gpqw2582yt8n">
          <span className="hidden text-[10px] font-semibold uppercase tracking-label text-cream-muted sm:inline" data-id="element-282" data-mp="3bqnqmjo6ul05">
            Ends in
          </span>
          <span className="font-semibold tabular-nums text-amber text-xs sm:text-sm" data-id="element-283" data-mp="1ex2ppn053pon">
            {hours}:{minutes}:{seconds}
          </span>
        </p>
      </div>
    </div>;
}